<script>
  import { afterUpdate } from 'svelte';
  import { vec2 } from 'gl-matrix';
  import ColorPicker from '../../../components/ColorPicker/ColorPicker.svelte';
  import { colorPickerStore } from './ColorPickerStore';
  let realX;
  let realY;

  let position = colorPickerStore.position;
  let isVisible = colorPickerStore.isVisible;
  let colorPickerColor = colorPickerStore.color;
  let elm;
  let colorPicker;

  afterUpdate(() => {
    let pos = $position;
    if ($isVisible) {
      setPosition(pos[0], pos[1]);
    }
  });

  function setPosition(x, y) {
    if (elm !== undefined && elm !== null) {
      let rect = elm.getBoundingClientRect();
      realX = x - rect.width / 2;
      realY = y + 10;
      if (realX < 0) {
        realX = 0;
      }
      if (realX + rect.width > window.innerWidth) {
        realX = window.innerWidth - rect.width;
      }

      if (realY + rect.height > window.innerHeight) {
        realY = window.innerHeight - rect.height;
      }
    }
  }

  function bodyMouseMove(event) {
    if ($isVisible) {
      let rect = elm.getBoundingClientRect();
      let centerX = rect.x + rect.width / 2;
      let centerY = rect.y + rect.height / 2;
      let distToCenter = vec2.sub(
        vec2.create(),
        [event.clientX, event.clientY],
        [centerX, centerY]
      );
      if (
        Math.abs(distToCenter[0]) > 220 ||
        (Math.abs(distToCenter[1]) > 220 && !colorPicker.isMouseDown())
      ) {
        $isVisible = false;
      }
    }
  }

  function bodyMouseDown(event) {
    if ($isVisible) {
      if (!elm.contains(event.target)) {
        $isVisible = false;
      }
    }
  }

  function onColorChange(newColor) {
    colorPickerStore.emit(newColor);
  }
</script>

<svelte:body on:pointermove={bodyMouseMove} on:pointerdown={bodyMouseDown} />
{#if $isVisible}
  <div
    bind:this={elm}
    class="dialog"
    style={`left: ${realX}px; top: ${realY}px`}
  >
    <ColorPicker
      bind:this={colorPicker}
      value={$colorPickerColor}
      onChange={onColorChange}
    />
  </div>
{/if}

<style>
  .dialog {
    position: absolute;
    padding: 12px;
    background-color: var(--color-2);
    border: 1px solid var(--color-4);
    z-index: 10;

    touch-action: none;
  }
</style>
